var _path, _path2, _mask, _rect, _path3, _mask2, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6741 0.953125H4.78681C2.54655 0.953125 0.730469 2.76921 0.730469 5.00946V68.8968C0.730469 71.137 2.54655 72.9531 4.78681 72.9531H68.6741C70.9144 72.9531 72.7305 71.137 72.7305 68.8968V5.00946C72.7305 2.76921 70.9144 0.953125 68.6741 0.953125Z",
    fill: "#146EB4",
    fillOpacity: 0.1,
    stroke: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2305 56.9531H11.2305C10.9543 56.9531 10.7305 57.177 10.7305 57.4531C10.7305 57.7293 10.9543 57.9531 11.2305 57.9531H62.2305C62.5066 57.9531 62.7305 57.7293 62.7305 57.4531C62.7305 57.177 62.5066 56.9531 62.2305 56.9531Z",
    fill: "#146EB4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_46503_251220",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.7305,
    y: 14.9531,
    width: 14,
    height: 14,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7305,
    y: 14.9531,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#146EB4",
    strokeWidth: 5,
    mask: "url(#path-3-inside-1_46503_251220)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7305 21.9531H52.7305",
    stroke: "#146EB4",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_46503_251220",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.7305,
    y: 32.9531,
    width: 14,
    height: 14,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7305,
    y: 32.9531,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#146EB4",
    strokeWidth: 5,
    mask: "url(#path-5-inside-2_46503_251220)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7305 39.9531H52.7305",
    stroke: "#146EB4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActiveIcon);
export default __webpack_public_path__ + "static/media/list-active-icon.67277e9a11ae05d90b52656cccf98a3c.svg";
export { ForwardRef as ReactComponent };